export class FilterRenderer {
  constructor(container) {
    this.container = container;
  }

  render() {
    this.container.innerHTML = `
      <div class="panel-header">
        <h3 class="panel-title">
          <i class="fas fa-filter panel-icon"></i>
          Filter Mines
        </h3>
      </div>
      <div class="panel-content">
        <div class="artisanal-mines-filter">
          <label class="artisanal-mines-toggle">
            <input type="checkbox" id="artisanalMinesToggle" />
            <span class="toggle-slider"></span>
            <span class="toggle-label">Artisanal Mines</span>
          </label>
          <span class="artisanal-mines-count" id="artisanalMinesCount" style="display: none;"></span>
          <div class="artisanal-mines-note">Africa: <a href="https://ipisresearch.be/home/maps-data/open-data/" target="_blank" rel="noopener">IPIS</a> (<a href="https://opendatacommons.org/licenses/by/1-0/" target="_blank" rel="noopener">ODC-By v1.0</a>) · SE Asia: <a href="https://www.stimson.org/program/mekong/" target="_blank" rel="noopener">Stimson Center</a></div>
        </div>
        <div class="filter-group">
          <label class="filter-label">Countries</label>
          <div class="custom-multi-select">
            <div class="multi-select-toggle">Select Countries</div>
            <div class="multi-select-options" data-filter="country"></div>
          </div>
        </div>
        <div class="filter-group">
          <label class="filter-label">Minerals</label>
          <div class="custom-multi-select">
            <div class="multi-select-toggle">Select Minerals</div>
            <div class="multi-select-options" data-filter="minerals"></div>
          </div>
        </div>
        <div class="filter-group">
          <label class="filter-label">Mine Type</label>
          <div class="custom-multi-select">
            <div class="multi-select-toggle">Select Type</div>
            <div class="multi-select-options" data-filter="mine_type"></div>
          </div>
        </div>
        <div class="filter-group">
          <label class="filter-label">Mine Status</label>
          <div class="custom-multi-select">
            <div class="multi-select-toggle">Select Status</div>
            <div class="multi-select-options" data-filter="mine_status"></div>
          </div>
        </div>
        <div class="filter-actions">
          <button class="filter-button reset" id="resetFilters">Reset to Defaults</button>
        </div>
      </div>
    `;
  }

  populateFilterOptions(filterOptions) {
    Object.entries(filterOptions).forEach(([filterType, options]) => {
      const container = this.container.querySelector(`[data-filter="${filterType}"]`);
      if (container && options.length > 0) {
        container.innerHTML = options.map(option => `
          <div class="multi-select-option">
            <input type="checkbox"
                   id="${filterType}-${option.value.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '')}"
                   value="${option.value}"
                   data-filter="${filterType}">
            <span class="checkmark"></span>
            <label for="${filterType}-${option.value.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '')}" title="${option.value}">
              ${option.label} ${option.count ? `(${option.count})` : ''}
            </label>
          </div>
        `).join('');
      }
    });
  }

  updateMultiSelectText(filterType, selectedCount) {
    const filterElement = this.container.querySelector(`[data-filter="${filterType}"]`);
    if (!filterElement) return;

    const multiSelect = filterElement.closest('.custom-multi-select');
    if (!multiSelect) return;

    const toggle = multiSelect.querySelector('.multi-select-toggle');
    if (!toggle) return;

    if (selectedCount === 0) {
      const labels = {
        country: 'Select Countries',
        commodity: 'Select Commodities',
        mine_type: 'Select Types',
        mine_status: 'Select Status'
      };
      toggle.textContent = labels[filterType] || 'Select Options';
    } else {
      toggle.textContent = `${selectedCount} selected`;
    }
  }

  updateUIFromFilters(filters) {
    if (!filters) {
      filters = {};
    }

    Object.entries(filters).forEach(([filterType, values]) => {
      if (Array.isArray(values)) {
        const checkboxes = this.container.querySelectorAll(`input[data-filter="${filterType}"]`);
        checkboxes.forEach(checkbox => {
          checkbox.checked = values.includes(checkbox.value);
        });
        this.updateMultiSelectText(filterType, values.length);
      }
    });
  }

  resetUI() {
    this.container.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.checked = false;
    });

    ['country', 'commodity', 'mine_type', 'mine_status'].forEach(filterType => {
      this.updateMultiSelectText(filterType, 0);
    });
  }
}